(ns minorodata.health.events
  (:require [re-frame.core :as re-frame]))

(re-frame/reg-event-db
 :health.events/set-dashboard-url
 (fn [db [_ id url status]]
   (assoc-in db [:dashboards id] {:signed-url url :status status})))
